import { all, takeLatest, call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { fetchSummaryActions } from '@/redux/actions/service-directory/summary';
import { SummaryInstance } from '@/services/service-directory/summary';

export function* fetchSummarySaga(action: ActionType<typeof fetchSummaryActions.request>) {
  try {
    const {
      region,
      country,
      entityTypes,
      complianceGroups,
      includeCountries,
      apiCategories,
      appFeatures,
      features,
    } = action.payload;
    const response = yield call(
      SummaryInstance.fetchSummaries,
      region,
      country,
      entityTypes,
      complianceGroups,
      apiCategories,
      appFeatures,
      includeCountries,
      features
    );
    yield put(fetchSummaryActions.success(response));
  } catch (err) {
    yield put(fetchSummaryActions.failure(err));
  }
}

export default function* root() {
  yield all([takeLatest(fetchSummaryActions.request.type, fetchSummarySaga)]);
}
